module.exports = __webpack_public_path__ + "static/media/video-4.da509444.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/video-4.webm
// module id = 157
// module chunks = 0